import { Component } from 'react'
import { Register, TabMedRecordsWithAudit, TabPersonalWithAudit, TabRouteWithAudit } from '@src/modules/monitoring/components'
import { REGISTER_COLUMNS, URLS } from '@src/constants'
import config from '@src/config'
import { TabStatusWithAudit } from './TabStatus'

export class RegisterProfPmoTeen extends Component {
  get basepath () {
    return URLS.MONITORING__PROF__PMO_TEEN
  }

  get navTitle () {
    return 'Реестр несовершеннолетних, проходящих ПМО'
  }

  get columns () {
    return [
      { type: REGISTER_COLUMNS.FULLNAME, settings: { column: { enabled: true } } },
      { type: REGISTER_COLUMNS.SNILS, settings: { column: { enabled: true } } },
      { type: REGISTER_COLUMNS.BIRTH_DATE, settings: { column: { enabled: true } } },
      { type: REGISTER_COLUMNS.GENDER_CODE, settings: { column: { enabled: true } } },
      { type: REGISTER_COLUMNS.OCC_BEGIN_ON, settings: { column: { enabled: true } } },
      { type: REGISTER_COLUMNS.MO_NAME, settings: { column: { enabled: true } } },
      { type: REGISTER_COLUMNS.DIAG_LIST, settings: { column: { enabled: true } } },
    ]
  }

  get tabs () {
    return [
      TabStatusWithAudit,
      TabMedRecordsWithAudit,
      TabPersonalWithAudit,
      ...(config.app.modules.enabled.monitoring_routes ? [TabRouteWithAudit] : []),
    ]
  }

  render () {
    return <Register
      list_type='9'
      columns={this.columns}
      basepath={this.basepath}
      navTitle={this.navTitle}
      tabs={this.tabs}
    />
  }
}
